export default "__VITE_ASSET__cac6f685__"